import React from 'react';
import clsx from 'clsx';

import PlaceholderOne from '@/assets/images/canvas/placeholder-1.svg?react';
import PlaceholderTwo from '@/assets/images/canvas/placeholder-2.svg?react';
import PlaceholderPlus from '@/assets/images/canvas/placeholder-plus.svg?react';

interface CanvasContentEmptyProps {
  className: string;
  onClick?: () => void;
  text: string;
  hideIllustration?: boolean;
}

export const CanvasContentEmpty: React.FC<CanvasContentEmptyProps> = ({
  className = '',
  onClick,
  text = 'Select or drag and drop elements here to edit the content',
  hideIllustration = false,
}) => {
  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <div
      onClick={handleClick}
      className={clsx(
        'group relative flex cursor-pointer flex-col items-center justify-center transition-all',
        className,
      )}
    >
      {!hideIllustration && (
        <>
          <div className="relative flex pt-6">
            <PlaceholderPlus className="absolute top-9 left-[44px] h-auto w-full max-w-[22px] transition-transform duration-300 group-hover:-translate-x-1 group-hover:-translate-y-1" />
            <PlaceholderOne className="mt-6 h-auto w-full max-w-[108px] transition-transform duration-300 group-hover:-translate-x-1 group-hover:-translate-y-1" />
            <PlaceholderTwo className="roup-hover:translate-y-2 mt-6 ml-[-68px] h-auto w-full max-w-[108px] transition-transform duration-300 group-hover:translate-x-1" />
          </div>
          {text && <p className="text-xs font-medium text-gray-600">{text}</p>}
        </>
      )}
    </div>
  );
};
